import { CommonModule } from "@angular/common";
import { Component, Injectable, OnInit, NgZone } from "@angular/core";
import { FormsModule } from "@angular/forms";
import {
  NavController,
  NavParams,
  LoadingController,
  ModalController,
  ToastController,
  IonicModule,
  AlertController,
} from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { BarcodeScanningModalComponent } from "src/app/components/barcode-scanning/barcode-scanning";
import { Barcode, BarcodeScanner, LensFacing } from "@capacitor-mlkit/barcode-scanning";
import { SemRegistroComponent } from "src/app/components/sem-registro/sem-registro";
import { ImagePipe } from "src/app/pipes/image/image";
import { CultoProvider } from "src/app/services/culto/culto";
import { LoadingSpinnerComponent } from "src/app/components/loading/loading-spinner/loading-spinner.component";

@Injectable({ providedIn: "root" })
@Component({
  selector: "app-culto-lista-presenca-encarregados",
  templateUrl: "./culto-lista-presenca-encarregados.page.html",
  styleUrls: ["./culto-lista-presenca-encarregados.page.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ImagePipe,
    TranslateModule,
    SemRegistroComponent,
    LoadingSpinnerComponent,
  ],
})
export class CultoListaPresencaEncarregadosPage implements OnInit {
  idCulto: string;
  idCultoAgenda: string;
  dataInicio: string;
  liderados: any = [];
  filtro: any = { q: "" };
  pagination: any = { currentPage: 0, pageCount: 0 };
  encarregadoList: any = [];
  loaded = true;
  public loadingPresenca: { [idPessoa: string]: boolean } = {};

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public loadingController: LoadingController,
    public modalCtrl: ModalController,
    public cultoProvider: CultoProvider,
    private alertCtrl: AlertController,
    private translate: TranslateService,
    private toastCtrl: ToastController,
    private readonly ngZone: NgZone
  ) {
    this.idCulto = this.navParams.get("idCulto");
    this.idCultoAgenda = this.navParams.get("id");
    this.dataInicio = this.navParams.get("dataInicio");

    this.loadEncarregados(null);
  }

  ngOnInit() {}

  public closeModal() {
    this.modalCtrl.dismiss(this.idCultoAgenda);
  }

  async leitor() {
    await this.checkPermission();
    const formats = LensFacing.Back || [];
    const lensFacing = LensFacing.Back;

    const element = await this.modalCtrl.create({
      component: BarcodeScanningModalComponent,
      cssClass: "barcode-scanning-modal",
      showBackdrop: false,
      componentProps: {
        formats: formats,
        lensFacing: lensFacing,
        text: "Buscar Responsável",
      },
    });
    element.present();

    element.onDidDismiss().then(async (result: any) => {
      const barcode: Barcode | undefined = result.data?.barcode;

      if (barcode?.displayValue) {
        const code = this.tratarCodigoScaneado(barcode?.displayValue);
        if (code) {
          this.cultoProvider.setPresencaBarcode(code.C, this.idCultoAgenda).subscribe(async (data) => {
            const toast = await this.toastCtrl.create({
              message: this.translate.instant("Presença salva com sucesso!"),
              duration: 3000,
            });

            toast.present();
            this.pagination = { currentPage: 0, pageCount: 0 };
            this.loadEncarregados(null);
          });
        } else {
          BarcodeScanner.stopScan();
          const alert = await this.alertCtrl.create({
            cssClass: "alerta-personalizado",
            mode: "ios",
            header: this.translate.instant("Atenção"),
            message: this.translate.instant(
              "Não foi possível abrir a câmera do celular. Valide as permissões do aplicativo"
            ),
            buttons: [
              {
                text: this.translate.instant("Fechar"),
              },
            ],
          });

          alert.present();
        }
      }
    });
  }

  async checkPermission() {
    BarcodeScanner.checkPermissions().then((result) => {
      if (result.camera != "granted") {
        return;
      }
    });

    BarcodeScanner.removeAllListeners().then(() => {
      BarcodeScanner.addListener("googleBarcodeScannerModuleInstallProgress", (event) => {
        this.ngZone.run(() => {
          const { state, progress } = event;
        });
      });
    });
  }

  tratarCodigoScaneado(code: any) {
    var aux = JSON.parse(code);
    return aux;
  }

  async changePresenca(p: { presenca: string; id: any }) {
    const id = p.id;
    this.loadingPresenca[id] = true;
    const presencaAtual = p.presenca === "1" ? "0" : "1";
    let data = { id: p.id, presenca: presencaAtual };

    this.cultoProvider.confirmarPresenca(data).subscribe(async (res) => {
      if (!res.error) {
        this.liderados = this.liderados.map((item: { idPessoa: any; presenca: string }) => {
          if (item.idPessoa === p.id) {
            return {
              ...item,
              presenca: presencaAtual,
            };
          }
          return item;
        });

        this.showAlert(this.translate.instant("Presença salva com sucesso!"));
      } else {
        this.showAlert(this.translate.instant("Ocorreu um erro ao salvar a presença!"));
      }

      setTimeout(() => {
        this.loadingPresenca[id] = false;
      }, 1000);
    });
  }

  loadEncarregados(infiniteScroll: any) {
    this.pagination.currentPage++;
    this.cultoProvider.getEncarregados(this.filtro, this.pagination, this.idCultoAgenda).subscribe((res) => {
      if (!infiniteScroll) {
        this.encarregadoList = [];
      }

      this.encarregadoList = this.encarregadoList.concat(res.encarregados);
      this.pagination = res.pagination;

      if (infiniteScroll) infiniteScroll.complete();
      setTimeout(() => {
        this.loaded = false;
      }, 1000);
    });
  }

  onCancel() {
    this.pagination = { currentPage: 0, pageCount: 0 };
  }

  onInput() {
    this.loadEncarregados(null);
  }

  async showAlert(message: string) {
    const toast = await this.toastCtrl.create({
      message: message,
      duration: 3000,
    });
    toast.dismiss();
    toast.present();
  }
}
